import { Typography } from "@sidelinesports/fan-design-system";
import { DblChevronRightIcon } from "@sidelinesports/icons";
import type { ApiGameMessage } from "../../../../../api/index.ts";
import { UploadedImage } from "../../../../../components/UploadedImage.tsx";
import { useExternalLinkProps } from "../../../../../hooks/index.ts";
import styles from "./FeaturedMessage.module.css";

export const FeaturedMessageItem = ({
  message,
}: {
  message: ApiGameMessage;
}) => {
  return (
    <MessageWrapper link={message.link}>
      {message.image ? (
        <div className={styles.imageContainer}>
          <UploadedImage
            image={message.image}
            alt=""
            className={styles.image}
            tracking={{ enabled: true, location: "LiveFeed::FeaturedMessage" }}
          />
        </div>
      ) : (
        <div
          style={{
            height: "10.25rem",
          }}
        />
      )}
      <Typography size="lg" className={styles.heading}>
        {message.text}
        {message.link && <DblChevronRightIcon className={styles.icon} />}
      </Typography>
    </MessageWrapper>
  );
};

const MessageWrapper = ({
  children,
  link,
}: {
  link: string | null;
  children: React.ReactNode;
}) => {
  const linkProps = useExternalLinkProps(link || "", {
    utm: {
      content: "live-feed-featured-message",
    },
  });

  if (link) {
    return (
      <a
        className={styles.container}
        data-track-link-name={`Featured Message: ${link}`}
        {...linkProps}
      >
        {children}
      </a>
    );
  }

  return <div className={styles.container}>{children}</div>;
};
